/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TradeApprovalRequestResponse } from '../../models/trade-approval-request-response';

export interface GetTradeScheduleRequest$Params {

/**
 * Trade request id.
 */
  id: number;
}

export function getTradeScheduleRequest(http: HttpClient, rootUrl: string, params: GetTradeScheduleRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<TradeApprovalRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, getTradeScheduleRequest.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TradeApprovalRequestResponse>;
    })
  );
}

getTradeScheduleRequest.PATH = '/api/scheduler/trade-schedule-requests/{id}';
